import { PatientConsditions } from "./PatientConditions";

export class Patient {
  patientId: number = 0;
  name: string = "";
  age?: number;
  weight?: number;
  height?: number;
  gender?: string;
  createdAt: Date = new Date();
  clinicalNote?: string = "";
  
  patientConditions: PatientConsditions = new PatientConsditions();

  constructor(init?: Partial<Patient>) {
    if (init) Object.assign(this, init);
  }

  static cloneFrom(original: Patient): Patient {
    const copy = new Patient();

    copy.patientId = original.patientId;
    copy.name = original.name;
    copy.age = original.age;
    copy.weight = original.weight;
    copy.height = original.height;
    copy.gender = original.gender;
    copy.createdAt = new Date(original.createdAt); 
    copy.clinicalNote = original.clinicalNote;
    copy.patientConditions = new PatientConsditions(original.patientConditions);

    return copy;
  }

  loadFromJson(json: any): this {
    if (!json) return this;

    this.patientId = json.patientId ?? 0;
    this.name = json.name ?? "";
    this.age = json.age ?? undefined;
    this.weight = json.weight ?? undefined;
    this.height = json.height ?? undefined;
    this.gender = json.gender ?? undefined;
    this.createdAt = json.createdAt ? new Date(json.createdAt) : this.createdAt;
    this.clinicalNote = json.clinicalNote ?? "";

    return this;
  }

  static fromJson(json: any): Patient {
    return new Patient().loadFromJson(json);
  }

  toJson(){
     const json: any = {};
  json.name = this.name;
  if (this.age != null) json.age = this.age;
  if (this.gender != null) json.gender = this.gender;
  if (this.weight != null) json.weight = this.weight;
  if (this.height != null) json.height = this.height;
  if (this.clinicalNote != null) json.clinicalNote = this.clinicalNote;
  return json;
  }

  isEqual(p2: Patient){
    let res = true;
    if(this.name !==  p2.name) return false;
    else if( this.age !== p2.age) return false;
    else if ( this.weight !== p2.weight) return false;
    else if( this.height !== p2.height) return false;
    else if( this.gender!== p2.gender) return false;
    return res;
  }
}
